import React, { FC, memo, ReactElement, useCallback } from 'react';
import { Contract, ContractItem } from 'entities/Contract';
import { useRejectPriceRaise } from '../utils/hooks/useRejectPriceRaise';

interface RejectPriceRaiseProps {
  contract: Contract;
  newPrice: number;
  oldPrice?: number;
  contractItem?: Nullable<ContractItem>;
  contractItemPriceRaiseId?: string;
  action: ReactElement;
}

export const RejectPriceRaise: FC<RejectPriceRaiseProps> = memo((props) => {
  const { action, contract, newPrice, oldPrice, contractItem, contractItemPriceRaiseId } = props;

  const { openRejectPriceRaise, rejectPriceRaiseModal } = useRejectPriceRaise();

  const openModal = useCallback((): void => {
    openRejectPriceRaise({
      contract,
      newPrice,
      oldPrice,
      contractItem,
      contractItemPriceRaiseId,
    });
  }, [contract, contractItem, contractItemPriceRaiseId, newPrice, oldPrice, openRejectPriceRaise]);

  return (
    <>
      {React.cloneElement(action, { onClick: openModal })}
      {rejectPriceRaiseModal}
    </>
  );
});
